export default __webpack_public_path__ + "static/media/Skytr.e058c5fb.png";